export let TaxpayerBannerType;

(function (TaxpayerBannerType) {
  TaxpayerBannerType["Info"] = "info";
  TaxpayerBannerType["Success"] = "success";
  TaxpayerBannerType["Warning"] = "warning";
  TaxpayerBannerType["Error"] = "error";
})(TaxpayerBannerType || (TaxpayerBannerType = {}));

export let TaxpayerBannerTrackingId;

(function (TaxpayerBannerTrackingId) {
  TaxpayerBannerTrackingId["FirstReminder"] = "first_reminder";
  TaxpayerBannerTrackingId["SecondReminder"] = "second_reminder";
  TaxpayerBannerTrackingId["NoFillReminder"] = "no_fill_reminder";
  TaxpayerBannerTrackingId["SellingBlocked"] = "selling_blocked";
  TaxpayerBannerTrackingId["Restricted"] = "restricted";
})(TaxpayerBannerTrackingId || (TaxpayerBannerTrackingId = {}));